export default "__VITE_ASSET__3df18ea8__"